import { ZERO_PLACEHOLDER } from './constants'

/**
 * Normalizes amount values by treating 0, 0.00, and empty as equivalent
 * @param amount - The amount value to normalize
 * @returns Normalized amount string or empty string for zero values
 */
export const normalizeAmount = (amount: string | undefined | null): string => {
  if (!amount || amount === '0' || amount === ZERO_PLACEHOLDER) {
    return ''
  }
  return amount
}
